import { render, staticRenderFns } from "./o-add-peers-modal.vue?vue&type=template&id=345a792e&scoped=true&"
import script from "./o-add-peers-modal.vue?vue&type=script&lang=js&"
export * from "./o-add-peers-modal.vue?vue&type=script&lang=js&"
import style0 from "./o-add-peers-modal.vue?vue&type=style&index=0&id=345a792e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345a792e",
  null
  
)

export default component.exports